"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M352.6 361.1c-20.6 20.2-46.5 31.5-75.2 35.4-50.2 6.9-94.2-6.7-130.4-43.1-55.8-55.8-56-148.1-1-205.2 55.6-57.3 141.9-62.1 202.1-10.8 1.5 1 2.3 1.9 2.5 2.3l-42.9 42.9c-43.8-26-79.8-26-110.4 1.5-29 25.6-37.9 66.5-22.7 101.7 16 36.5 50 55.4 92.7 51.2 31.7-2.9 56.9-24.8 63.5-56h-77.9v-59.6h139.8c7.6 52.8-1 100.7-40.1 139.7z"
  });
};

exports.default = _default;